import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import locale from 'element-ui/lib/locale';
import { DatePicker } from 'element-ui';

locale.use(zhTW);
Vue.component(DatePicker.name, DatePicker);

import '@/plugins/bootstrapVue.js';
import '@/plugins/veeValidate.js';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
